import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import React from "react";

import { closeModalActionCreator } from "../../../redux/actions/modalActions";
import { patchPermissions } from "../../../redux/operations/adminOperations";

import { moderatorFormConfig } from "./ModeratorForm.config";
import { moderatorFormSchema } from "./ModeratorForm.schema";
import { adminSelector } from "../../../redux/selectors/adminSelectors";
import "./ModeratorForm.scss";
import Button from "../../../shared/Button/Button";

const ModeratorForm = ({ details: { permissions, _id, role } }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { loading } = useSelector(adminSelector);

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        mode: "all",
        defaultValues: permissions,
        resolver: yupResolver(moderatorFormSchema),
    });

    const handleCloseModal = () => dispatch(closeModalActionCreator());

    const handleFormSubmit = (data) => {
        dispatch(patchPermissions(_id, role, data));
    };

    return (
        <form
            className="moderator_form"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="moderator_form__content">
                <h2 className="moderator_form__title">{t("edit-moderator")}</h2>
                <div className="moderator_form__items">
                    {moderatorFormConfig.map(({ label, value }) => (
                        <div key={value} className="moderator__item">
                            <label className="moderator__item_label">
                                {t(label)}
                            </label>
                            <select
                                className={`moderator__item_select ${
                                    errors[value] ? "error" : ""
                                }`}
                                {...register(value)}
                            >
                                <option value={true}>{t("yes")}</option>
                                <option value={false}>{t("no")}</option>
                            </select>
                            {errors[value] && (
                                <span className="moderator__item-error">
                                    {t(errors[value].message)}
                                </span>
                            )}
                        </div>
                    ))}
                    <div className="moderator__service">
                        <Button
                            onClick={handleCloseModal}
                            buttonStyle={"btn--red"}
                        >
                            {t("btn-cancel")}
                        </Button>
                        <Button
                            type="submit"
                            buttonStyle={"btn--green"}
                            loading={loading}
                        >
                            {t("btn-save")}
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ModeratorForm;
